angular
	.module 'App.Component'
	.component 'cronInput',
	{
		templateUrl: '@component/input/cron-input/cron-input.view.html'
		controller: 'CronInputController'
		controllerAs: 'cronInput'
		bindings:
			entity: '<'
	}

class CronInputController extends AbstractController
	@register()
	@inject 'translate',
		'SHORT_TIME_FORMAT'

	initialize: ->
		if !(@entity instanceof CronDTO)
			throw new Error('Entity must be a CronDTO instance');

		@datePickerConfiguration =
			timePicker: true
			timePickerOnly: true
			format: @SHORT_TIME_FORMAT

		@frequencies = [
			{
				id: 'daily',
				name: @translate 'wbo.cron_input.frequency.daily'
			},
			{
				id: 'weekly',
				name: @translate 'wbo.cron_input.frequency.weekly'
			},
		]
		@weekdays = [
			{
				id: 1,
				name: @translate 'wbo.monday'
			},
			{
				id: 2,
				name: @translate 'wbo.tuesday'
			},
			{
				id: 3,
				name: @translate 'wbo.wednesday'
			},
			{
				id: 4,
				name: @translate 'wbo.thursday'
			},
			{
				id: 5,
				name: @translate 'wbo.friday'
			},
			{
				id: 6,
				name: @translate 'wbo.saturday'
			},
			{
				id: 7,
				name: @translate 'wbo.sunday'
			},
		]
		@weekdaysTo = angular.copy @weekdays

	onWeekdaysChange: ->
		@weekdaysTo = _.filter(@weekdays, (weekday) => weekday.id >= @entity.weekdayFrom)

		if !_.find(@weekdaysTo, (weekdayTo) => weekdayTo.id == @entity.weekdayTo)
			@entity.weekdayTo = null
